import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import VideoPlayButton from './buttons/VideoPlayButton'
import VideoVolumeButton from './buttons/VideoVolumeButton'
import ScrubBar from './bars/VideoScrubBar'
import VideoQualityButton from './buttons/VideoQualityButton'
import OpacityHelper from 'aria-viewer/tour/components/opacityHelper'
import { mapSelectorsToProps } from 'aria-viewer/core/selectors/mapSelectorsToProps'
import mobileDetect from 'aria-viewer/utils/mobileDetect'
import { PLATFORM } from 'aria-viewer/tour/constants/'
import { stopAudio } from 'aria-viewer/audiomanager/audioManagerActions'
import { VIDEO_PLAY_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import QueryParamUtils from 'aria-viewer/utils/queryParamUtils'
import compose from 'recompose/compose'
import { MEDIA_TYPES } from 'aria-viewer/tour/constants'
import { VideoPlayer } from '../../../legacy'
import pure from 'recompose/pure'

const settingsButtonStyle = {
    position: 'absolute',
    top: '40%',
    width: '22px',
    height: '22px',
    transform: 'translateZ(1px)',
    pointerEvents: 'all',
}

const Style = {
    mobile: {
        uiContainer: {
            position: 'absolute',
            width: '100%',
            top: '24%',
            height: '60%',
        },

        skipButton: {
            position: 'absolute',
            right: '0',
            bottom: '0',
            pointerEvents: 'all',
        },

        centerPlayButton: {
            position: 'absolute',
            top: '0',
            left: '50%',
            transform: 'translate3d(-50%, 0%, 1px)',
            width: '102.4px',
            height: '102.4px',
            pointerEvents: 'all',
        },
        hidePlayButton: {
            position: 'absolute',
            opacity: '0',
            top: '0',
            left: '50%',
            transform: 'translate3d(-50%, 0%, 1px)',
            width: '102.4px',
            height: '102.4px',
        },

        volumeButton: {
            ...settingsButtonStyle,
            display: mobileDetect.mobile() ? 'none' : 'initial',
            left: '8%',
        },

        qualityButton: {
            ...settingsButtonStyle,
            right: '8%',
        },

        scrubContainer: isWalkingtour => null,

        scrubBar: isWalkingtour => ({
            position: 'absolute',
            left: '50%',
            bottom: isWalkingtour ? '28%' : '15%',
            transform: 'translate(-50%) translateZ(1px)',
            width: '83.5%',
            pointerEvents: 'all',
        }),

        scrubBarHeight: 4,

        qualityOffsetY: -50,
    },
    desktop: {
        uiContainer: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: '0',
            top: '0',
            zIndex: 2005,
            pointerEvents: 'none',
        },

        skipButton: {
            position: 'absolute',
            right: '0',
            bottom: '0.4em',
        },

        playButton: {
            position: 'absolute',
            top: '50%',
            left: 10,
            transform: 'translateY(-50%) translateZ(1px)',
            width: 50,
            height: 50,
            cursor: 'pointer',
        },

        centerPlayButton: {
            position: 'absolute',
            left: 10,
            cursor: 'pointer',
            top: '50%',
            left: '50%',
            transform: 'translate3d(-50%, -50%, 1px)',
            pointerEvents: 'all',
            width: '110px',
            height: '110px',
        },

        hidePlayButton: {
            position: 'absolute',
            opacity: '0',
            top: '0',
            left: '50%',
            transform: 'translate3d(-50%, -50%, 1px)',
            width: '102.4px',
            height: '102.4px',
        },

        playButtonStrokeWidth: 0,

        playButtonFill: 'none',

        volumeButton: {
            ...settingsButtonStyle,
            right: '25px',
            top: '30%',
            width: '18px',
            height: '18px',
            padding: '25px 0px 0px 0px',
            background: 'rgba(8, 19, 30, 0)',
            cursor: 'pointer',
            transform: 'translateY(-50%) translateZ(1px)',
        },

        qualityButton: {
            ...settingsButtonStyle,
            right: '55px',
            top: '50%',
            width: '18px',
            height: '18px',
            padding: '0px',
            background: 'rgba(8, 19, 30, 0)',
            cursor: 'pointer',
            transform: 'translateY(-50%) translateZ(1px)',
        },

        scrubContainer: isWalkingtour => ({
            position: 'absolute',
            left: '50%',
            bottom: '10px',
            transform: 'translate(-50%) translateZ(1px)',
            background: 'rgba(8, 19, 30, 0.5)',
            borderRadius: '18px',
            width: '620px',
            height: '60px',
            boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.5)',
            pointerEvents: 'all',
        }),

        scrubBar: isWalkingtour => ({
            position: 'relative',
            width: '476px',
            top: '25px',
            left: '60px',
            videoDuration: { fontSize: '14px' },
        }),

        scrubBarHeight: 2,

        scrubBarMarkerWidth: 2,

        scrubBarMarkerHeight: 14,

        scrubBarMarkerTop: -12,

        qualityOffsetY: -36,
    },
}

const preventEventBubbling = e => {
    e && e.stopPropagation && e.stopPropagation()
    e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation()
    e && e.preventDefault && e.preventDefault()
}

const VideoUIControls = pure(function VideoUIControls({ isWalkingtour, platformUsed, player, onChange }) {
    return (
        <div onClick={preventEventBubbling} id="video_ui_control_buttons">
            <VideoVolumeButton
                onChange={onChange}
                style={Style[platformUsed].volumeButton}
                player={player}
                theme={platformUsed}
                volumeHeight={platformUsed == PLATFORM.desktop ? 85 : null}
            />
            <VideoQualityButton
                onClick={onChange}
                style={Style[platformUsed].qualityButton}
                offsetY={Style[platformUsed].qualityOffsetY}
            />
            <ScrubBar
                onChange={onChange}
                style={Style[platformUsed].scrubBar(isWalkingtour)}
                player={player}
                height={Style[platformUsed].scrubBarHeight}
                markerWidth={Style[platformUsed].scrubBarMarkerWidth}
                markerHeight={Style[platformUsed].scrubBarMarkerHeight}
                markerTop={Style[platformUsed].scrubBarMarkerTop}
            />
        </div>
    )
})

const Theme = {
    //Custom PLATFORM for where this shows up
    modal: {
        mobile: {
            container: videoType => ({}),
            scrubContainer: () => ({
                bottom: 5,
                background: 'transparent',
                boxShadow: 'none',
            }),
            uiContainer: Object.assign({}, Style.mobile.uiContainer, {
                top: '0',
                height: '100%',
            }),
            playButton: Object.assign({}, Style.mobile.playButton, {
                top: '50%',
                transform: 'translate3d(-50%, -50%, 1px)',
            }),
        },
        desktop: {
            scrubContainer: isWalkingtour =>
                Object.assign({}, Style.desktop.scrubContainer(isWalkingtour), {
                    bottom: '32px',
                    overflow: 'visible',
                }),
        },
    },
}

class VideoPlayerUI extends PureComponent {
    constructor(props) {
        super(props)

        this.R = { videoUIControls: undefined }
    }
    static propTypes = {
        player: PropTypes.object.isRequired,
        platform: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired,
        onControlsHover: PropTypes.func,
        onControlsHoverEnd: PropTypes.func,
        //TODO -> define the rest of the interface properly
    }

    static defaultProps = {
        platform: { theme: PLATFORM.mobile },
    }

    componentDidMount() {
        // need manual binding for React glitch
        if (this.R.videoUIControls) {
            this.R.videoUIControls.addEventListener('mouseleave', this.props.onControlsHoverEnd)
        }
    }

    componentWillMount() {
        //Used for merging the props style with my theme
        const {
            theme: { platform, containerTheme, videoType },
        } = this.props
        this.theme = Object.assign(
            {},
            this.props.style,
            Theme[containerTheme] &&
                Theme[containerTheme][platform].container &&
                Theme[containerTheme][platform].container(videoType)
        )

        // need manual binding for React glitch
        if (this.R.videoUIControls) {
            this.R.videoUIControls.removeEventListener('mouseleave', this.props.onControlsHoverEnd)
        }
    }

    handleChange = e => {
        preventEventBubbling(e)
        const { onChange } = this.props

        onChange && onChange()
    }

    handlePlayButtonClick = e => {
        preventEventBubbling(e)

        // TODO: We should not call functions on the native player but rather on the VideoPlayerWrapper
        this.props.player.togglePlaying()
    }

    getCustomStyle = ({ customTheme, platform, style, playerType }) => {
        if (
            (playerType == VideoPlayer.types.YOUTUBE || playerType == VideoPlayer.types.VIMEO) &&
            style == 'uiContainer'
        ) {
            return { display: 'none' }
        }
        return (customTheme && customTheme[platform] && customTheme[platform][style]) || Style[platform][style]
    }

    render() {
        const {
            player,
            isWalkingtour,
            theme: { platform, containerTheme, hideControls },
            useResponsiveUI,
        } = this.props

        const customTheme = Theme[containerTheme]

        const hideMobileUIControls = platform == PLATFORM.mobile && player.type == VideoPlayer.types.YOUTUBE

        const hideCenterPlay =
            platform == PLATFORM.desktop && (this.props.isVideoPlaying || player.type == VideoPlayer.types.YOUTUBE)

        const platformUsed = platform.theme ? platform.theme : platform

        const containerStyle = this.getCustomStyle({
            customTheme,
            platform,
            style: 'uiContainer',
            playerType: player.type,
        })

        // TODO -> use MobileDetect API rather than platform == checks.
        // TODO -> (for future : use redux state slice with isMobile prop)

        return (
            !useResponsiveUI && (
                <div style={this.theme} id="video_ui_wrapper">
                    <div
                        style={containerStyle}
                        ref={c => (this.R.videoUIControls = c)}
                        onMouseEnter={this.props.onControlsHover}
                    >
                        <VideoPlayButton
                            isVideoPlaying={this.props.isVideoPlaying}
                            tabIndex={VIDEO_PLAY_BUTTON_INDEX}
                            onClick={this.handlePlayButtonClick}
                            buttonStyle={this.getCustomStyle({
                                customTheme,
                                platform,
                                style: !hideCenterPlay ? 'centerPlayButton' : 'hidePlayButton',
                            })}
                            strokeWidth={Style[PLATFORM.mobile].playButtonStrokeWidth}
                        />
                        <div style={(customTheme || Style)[platform].scrubContainer(isWalkingtour)}>
                            {platform == PLATFORM.desktop && (
                                <VideoPlayButton
                                    tabIndex={VIDEO_PLAY_BUTTON_INDEX}
                                    onClick={this.handlePlayButtonClick}
                                    buttonStyle={Style[platform].playButton}
                                    player={player}
                                    strokeWidth={Style[platform].playButtonStrokeWidth}
                                    isVideoPlaying={this.props.isVideoPlaying}
                                    fill={Style[platform].playButtonFill}
                                />
                            )}
                            {!hideControls && !hideMobileUIControls && (
                                <VideoUIControls
                                    onChange={this.handleChange}
                                    isWalkingtour={isWalkingtour}
                                    platformUsed={platformUsed}
                                    player={player}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )
        )
    }
}

export default compose(
    connect(state => ({
        useResponsiveUI: QueryParamUtils.useResponsiveUI(),
    })),
    connect(
        mapSelectorsToProps(['isWalkingtour']),
        {
            stopAudio,
        }
    )
)(VideoPlayerUI)
